import { Flex, Typography } from 'antd'

const { Text } = Typography

export const conversionColors = {
  green: '#a6e3a1',
  orange: '#ffc966',
  red: '#ff9999',
}

export type ConversionLegendMode = 'loss' | 'conversion'

export interface ConversionLegendItem {
  label: string
  color: string
}

// The Sankey expresses funnel drop-off (loss), while the heatmap expresses
// the opposite (conversion). Keep the wording mode-specific so the heatmap
// never ships the Sankey's "Loss" labels.
const legendItemsByMode: Record<ConversionLegendMode, ConversionLegendItem[]> =
  {
    loss: [
      { label: 'Loss > 60%', color: conversionColors.red },
      { label: 'Loss > 30%', color: conversionColors.orange },
      { label: 'Loss ≤ 30%', color: conversionColors.green },
    ],
    conversion: [
      { label: 'Conversion ≥60%', color: conversionColors.green },
      { label: 'Conversion 30–60%', color: conversionColors.orange },
      { label: 'Conversion <30%', color: conversionColors.red },
    ],
  }

interface Props {
  /** Which canned wording to use. Ignored when `items` is provided. */
  mode?: ConversionLegendMode
  /** Explicit legend items, overrides `mode`. */
  items?: ConversionLegendItem[]
}

export const ConversionLegend = ({ mode = 'loss', items }: Props) => {
  const legendItems = items ?? legendItemsByMode[mode]

  return (
    <Flex gap={24}>
      {legendItems.map((item, i) => (
        <Flex key={i} align="center" gap={6}>
          <div
            style={{
              width: 16,
              height: 16,
              backgroundColor: item.color,
              borderRadius: 4,
            }}
          />
          <Text style={{ fontSize: 12 }}>{item.label}</Text>
        </Flex>
      ))}
    </Flex>
  )
}
